<template>
	....code
</template>

<script>
export default {
	name: "ExampleComponent",
	props: {
	},
	data() {
		return {
		}
	}
}
</script>
